import { combineReducers } from "redux";

import user from "./user";
import store from "./store";
import template from "./template";

export default combineReducers({
  user,
  store,
  template,
});
